module.exports = __webpack_public_path__ + "static/media/visa.d1ca1cc0.png";